const $$splitComponentImporter = () => import('/Users/lois/Documents/GitHub/zephyr/repos/storage-viewer/src/routes/keys.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/keys')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});